import { api } from "./api";

const membershipServices = api.injectEndpoints({
  endpoints: (builder) => ({
    //getAllMemberDetails
    getAllMemberDetails: builder.query({
      query: () => "member/getall",
    }),

    //getMemberDetailsById
    getMemberDetailsById: builder.query({
      query: (id) => "member/get/" + id,
    }),

    //getMemberDetailsById
    // getHomePageTotalCount: builder.query({
    //   query: () => "member/homePageTotalCount"
    // }),
    //createMember
    createMember: builder.mutation({
      query: (newMemberData) => ({
        url: "member/createMember",
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        body: newMemberData,
      }),
    }),

    createDualMember: builder.mutation({
      query: (newMemberData) => ({
        url: "member/createDualMember",
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        body: newMemberData,
      }),
    }),

    //Update Member
    UpdateMember: builder.mutation({
      query: (data) => ({
        url: "member/updatemember/" + data.id,
        method: "PUT",
        body: data.formData,
      }),
    }),

    //Update plan Renewal
    UpdatePlansRenewal: builder.mutation({
      query: (data) => ({
        url: `member/updateMemberRenewal/`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
    }),
    getInstituteBasedOnState: builder.query({
      query: () => "member/getInstituteBasedOnState",
    }),
    homePageTotalCount: builder.query({
      query: () => "member/homePageTotalCount",
    }),
    //to approve the notpaid member list
    addNotPaidMember: builder.mutation({
      query: (newMemberData) => ({
        url: "/member/notPaidMember",
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        body: newMemberData,
      }),
    }),

    //updateChangeplan
    UpdateChangePlan: builder.mutation({
      query: ({ id, data }) => ({
        url: `member/updateChangePlan/` + id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
    }),
    cancelRenewal: builder.mutation({
      query: (id) => ({
        url: `member/cancelRenewal/` + id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
    }),
    //updateChangeplan
    searchMember: builder.mutation({
      query: (data) => ({
        url: `member/searchMember`,
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
    }),

    //Member Bulk Upload
    bulkUpload: builder.mutation({
      query: (newMemberData) => ({
        url: "/member/uploadExcel",
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        body: newMemberData,
      }),
    }),
    createMemberReport: builder.mutation({
      query: (newMemberData) => ({
        url: "member/membershipReport",
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        body: newMemberData,
      }),
    }),
    addressLabelPdf: builder.mutation({
      query: (newMemberData) => ({
        url: "member/generateAddressSlip",
        method: "POST",
        // headers: { "Content-Type": "application/json" },
        body: newMemberData,
      }),
    }),
    deleteAddressLabelPdf: builder.mutation({
      query: () => ({
        url: "member/deleteAddressSlipPDF",
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetAllMemberDetailsQuery,
  useLazyGetMemberDetailsByIdQuery,
  useCreateMemberMutation,
  useUpdateMemberMutation,
  useUpdatePlansRenewalMutation,
  useUpdateChangePlanMutation,
  useLazyGetInstituteBasedOnStateQuery,
  useCreateDualMemberMutation,
  useAddNotPaidMemberMutation,
  useSearchMemberMutation,
  useBulkUploadMutation,
  useHomePageTotalCountQuery,
  useCreateMemberReportMutation,
  useCancelRenewalMutation,
  useAddressLabelPdfMutation,
  useDeleteAddressLabelPdfMutation,
} = membershipServices;
